import {doc, updateDoc} from "firebase/firestore";
import {db} from "../Firebase";
import {kTracksCollectionName} from "../utils/CollectionConstants";

// LUFS analysis states: 'none' -> 'analyzing' -> 'ready'
export type LufsState = 'none' | 'analyzing' | 'ready';

/**
 * Mark track as having waveform ready.
 */
export const SetTrackHasWaveform = async ({trackId}: {trackId: string}) => {
    const entityRef = doc(db, kTracksCollectionName, trackId);
    try {
        await updateDoc(entityRef, {hasWaveform: true});
    } catch (error) {
        console.error('Error updating waveform state: ', error);
    }
};

/**
 * Update track LUFS analysis state and results.
 */
export const SetTrackLufsAnalysis = async ({
    trackId,
    lufsState,
    integratedLufs,
    recommendedGain,
}: {
    trackId: string;
    lufsState: LufsState;
    integratedLufs?: number;
    recommendedGain?: number;
}) => {
    const entityRef = doc(db, kTracksCollectionName, trackId);
    try {
        const update: Record<string, any> = { lufsState };
        if (integratedLufs !== undefined) update.integratedLufs = integratedLufs;
        if (recommendedGain !== undefined) update.recommendedGain = recommendedGain;
        await updateDoc(entityRef, update);
    } catch (error) {
        console.error('Error updating LUFS analysis: ', error);
    }
};
